import { AutofocusDirective } from '../../../../../../shared/directive/autofocus.directive';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@jsverse/transloco';
import { FormBaseComponent } from '@anihis/shared/src/shared/base-components/form-base.component';

@Component({
  selector: 'anihis-instruction-for-examination',
  standalone: true,
  imports: [
    AutofocusDirective,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatButtonModule,
    TranslocoModule,
  ],
  templateUrl: './instruction-for-examination.component.html',
  styleUrls: ['./instruction-for-examination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstructionForExaminationComponent
  extends FormBaseComponent
  implements OnInit
{
  @Output() formChange = new EventEmitter<any>();
  @Output() save = new EventEmitter<any>();

  constructor() {
    super();
    this.form = this.fb.group({
      instructionInfo: this.fb.group({
        institution: new FormControl('', [Validators.required]),
        medicalHistory: new FormControl('', [Validators.required]),
        requestedExamination: new FormControl('', [Validators.required]),
        note: new FormControl(''),
        veterinarianName: new FormControl(''),
      }),
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.subs.sink = this.form.valueChanges.subscribe((v) =>
      this.formChange.emit(v),
    );
  }

  onSubmit() {
    this.form.markAllAsTouched();
    if (this.form.valid) this.save.emit(this.form.value);
  }
}
